import { Expose, Transform } from 'class-transformer';
import { IsNotEmpty, IsString, IsUUID } from 'class-validator';
import { DeviceStatus } from '../../enums/auth';

export class UserAgentDto {
    @Expose()
    @IsString()
    parsedUserAgent: string;
}
